import { render, staticRenderFns } from "./multipleParames.vue?vue&type=template&id=30f56d92"
import script from "./multipleParames.vue?vue&type=script&lang=js"
export * from "./multipleParames.vue?vue&type=script&lang=js"
import style0 from "./multipleParames.vue?vue&type=style&index=0&id=30f56d92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports